/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "channels": {
        "nested": {
          "Reference": {
            "fields": {
              "type": {
                "type": ".squareup.channels.Reference.Type",
                "id": 1,
                "rule": "optional"
              },
              "id": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN_TYPE": 0,
                  "LOCATION": 1,
                  "FIRST_PARTY_INTEGRATION": 2,
                  "OAUTH_APPLICATION": 3,
                  "ONLINE_SITE": 4,
                  "ONLINE_CHECKOUT": 5,
                  "INVOICE": 6,
                  "GIFT_CARD": 7,
                  "GIFT_CARD_MARKETPLACE": 8,
                  "RECURRING_SUBSCRIPTION": 9,
                  "ONLINE_BOOKING_FLOW": 10,
                  "SQUARE_ASSISTANT": 11,
                  "CASH_LOCAL": 12,
                  "POINT_OF_SALE": 13,
                  "KIOSK": 14
                }
              }
            }
          },
          "Channel": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "version": {
                "type": "uint64",
                "id": 4,
                "rule": "optional"
              },
              "reference": {
                "type": ".squareup.channels.Reference",
                "id": 5,
                "rule": "optional"
              },
              "status": {
                "type": ".squareup.channels.Channel.Status",
                "id": 6,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "processedGdprForget": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "ACTIVE": 0,
                  "INACTIVE": 1
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.channels?.nested?.Reference && !$root.nested?.squareup?.nested?.channels?.nested?.Reference?.nested?.Type && !$root.nested?.squareup?.nested?.channels?.nested?.Channel && !$root.nested?.squareup?.nested?.channels?.nested?.Channel?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Reference @ squareup/channels/channels.proto at 27:1
 */
export const Reference = $root.lookupType('squareup.channels.Reference');
fixType(Reference);
Builder.createAndAttachToType(Reference);
/**
 * @desc The type of platform concept a channel can represent.
 *
 * SOURCE Type @ squareup/channels/channels.proto at 31:3
 */
Reference.Type = $root.lookupEnum('squareup.channels.Reference.Type').values;
/**
 * SOURCE Channel @ squareup/channels/channels.proto at 58:1
 */
export const Channel = $root.lookupType('squareup.channels.Channel');
fixType(Channel);
Builder.createAndAttachToType(Channel);
/**
 * SOURCE Status @ squareup/channels/channels.proto at 61:3
 */
Channel.Status = $root.lookupEnum('squareup.channels.Channel.Status').values;